import Header from "../../helperComponents/Header/header";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import './about.scss'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/skyblue';
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/core';
import PreFooter from "../../helperComponents/PreFooter/Prefooter";
import Footer from "../../helperComponents/Footer/Footer";
import gsap from "gsap";
import DuduElement from "../../helperComponents/DuduElement/duduElement";
import AwardsGallery from "../../helperComponents/Award/award";





export default function About() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });


    useEffect(() => {
        const tl1 = gsap.timeline();

        tl1.to(".about__containerText1", {
            duration: 1,
            y: 0,
            height: "fit-content",// Or an appropriate maximum height
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
            ease: "power4.inOut",
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .7,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        }, '-=.7')
    }, []);

    const galleryHeroArray = [
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640155/galleryHero1_wsbuhg.jpg',
        },
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640155/galleryHero4_gurzgk.jpg',
        },
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640150/galleryHero3_hfhm8o.jpg',
        },
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640200/galleryHero2_utnjrs.jpg',
        },
    ]

    const galleryNotHeroArray = [
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1781785457/qmgpaysriuwtwcbujuan.png',
        },
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1781785460/szfmo0dnuerniqerc9qq.png',
        },
        {
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1781785462/ibpm3ybv1d0ui46tqzvz.png',
        },
    ]
    
    const galleryHero8 = 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1781785464/vfyb7ruignuqcgr2axez.png';
    const galleryHero9 = 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1781785466/iiyukwzajmongvecpazs.png';


    return (
        <div className="about__container">
            <Header isHomepage={false} />
            <section style={{ padding: isMediumScreen ? '0 16px' : '0 70px' }}>
                <section style={{ textAlign: 'center', }} className="first__section">
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p className="about__containerText1" style={{ marginTop: isMediumScreen ? '80px' : '150px', marginBottom: isMediumScreen ? '50px' : '100px', fontSize: isMediumScreen ? '40px' : '100px', lineHeight: isMediumScreen ? '46px' : '110px', width: '80%', color: '#916859', }}>We elevate Event Planning<span style={{ fontStyle: 'italic' }}> through artful & intentional experiences</span></p>
                    </div>
                    <Splide options={{
                        rewind: true,
                        width: '100%',
                        gap: isAlmostMediumScreen ? "1em" : '2rem',
                        perPage: 1,
                        perMove: 1,
                    }} hasTrack={false} aria-label="...">
                        <SplideTrack>
                            {
                                galleryHeroArray.map((test) => (
                                    <SplideSlide className="splide_slide" style={{}}>
                                        <div>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    height: isMediumScreen ? '400px' : '862px',
                                                    backgroundImage: `url(${test.image.replace('/upload/', '/upload/q_auto,f_auto,w_1200/')})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                }}
                                                alt='Cross-section of events planned by Dudu&apos;s world.'
                                            ></div>
                                        </div>
                                    </SplideSlide>
                                ))
                            }
                        </SplideTrack>

                        <div className="splide__arrows" style={{ display: 'none' }}></div>
                    </Splide>
                </section>

                <section style={{ marginTop: '60px', display: 'flex', flexDirection: 'column', gap: isMediumScreen ? '100px' : '140px', }} className="second__section">
                    <div style={{ display: 'flex', flexDirection: isMediumScreen ? 'column' : 'row', gap: '50px', justifyContent: 'space-between', }}>
                        <div className="second__section1" style={{ flexBasis: '50%', flex: 1, display: 'flex', flexWrap: 'nowrap', gap: '8px', justifyContent: 'start', alignItems: 'start' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                            <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, color: '#916859' }}>OUR STORY</p>
                        </div>
                        <div className="second__section2" style={{ flexBasis: '50%', flex: 1 }}>
                            <p style={{ fontSize: isMediumScreen ? '36px' : '50px', lineHeight: isMediumScreen ? '44px' : '60px', fontWeight: 500, marginBottom: '50px', color: '#916859' }}>
                                Sharing <span style={{ fontStyle: 'italic' }}>the story & Birth</span> of Dudu&apos;s World of Entertainment.
                            </p>
                            <p style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '35px', color: '#916859', marginBottom: '30px' }}>
                                Founded in 2009 by the Nigerian-born Event Planner Modupe Sonayon,
                                Dudu&apos;s World of Entertainment is an African brand which specializes in the
                                craft of Event Planning & Management. In the past we&apos;ve worked with reputable
                                Nigerian based clients such as Cowbell and many more. While in the space of 2 years
                                we&apos;ve worked with over 20 reputable Canadian based clients.
                            </p>
                            <p style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '35px', color: '#916859' }}>
                                To mention a few such as the popular Actress Kudi Dollar @ 40, the popular Prince Wale Olusi @
                                50 and many more. We also run a podcast called Tales by Dudu, whose main purpose is to encourage
                                people who have doubts and fears of becoming entrepreneurs. we do this by bringing on those who have
                                experienced success in the field.
                            </p>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: isMediumScreen ? 'column' : 'row', gap: '50px', justifyContent: 'space-between', }}>
                        <div className="second__section1" style={{ flexBasis: '50%', flex: 1, display: 'flex', flexWrap: 'nowrap', gap: '8px', justifyContent: 'start', alignItems: 'start' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                            <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, color: '#916859' }}>OUR MISSION</p>
                        </div>
                        <div className="second__section2" style={{ flexBasis: '50%', flex: 1 }}>
                            <p style={{ fontSize: isMediumScreen ? '36px' : '50px', lineHeight: isMediumScreen ? '44px' : '60px', fontWeight: 500, marginBottom: '50px', color: '#916859' }}>
                                Discover <span style={{ fontStyle: 'italic' }}>the Mission statement</span> of Dudu&apos;s World of Entertainment.
                            </p>
                            <p style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '35px', color: '#916859', marginBottom: '30px' }}>
                                At Dudu&apos;s World of Entertainment we aim at bringing our clients dreams and ideas to life,
                                through creating artful & innovative memorable experiences. By doing this we get the utmost
                                form of satisfaction when smiles are brought to our clients&apos; faces.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="third__section" style={{ marginTop: isMediumScreen ? '50px' : '162px', marginBottom: '100px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexDirection: isMediumScreen ? 'column' : 'row' }}>
                        {galleryNotHeroArray.map((child) => (
                            <div
                                style={{
                                    width: '100%',
                                    backgroundImage: `url(${child.image.replace('/upload/', '/upload/q_auto,f_auto,w_800/')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                                alt='Dudus&apos; world in her element.'
                            ></div>
                        ))}
                    </div>
                </section>

                <section className="fourth__section" style={{ display: 'flex', flexDirection: 'column', gap: isMediumScreen ? '50px' : '100px' }}>
                    <div className="fourth__section1" style={{ display: 'flex', flexDirection: isMediumScreen ? 'column' : 'row', gap: '50px', justifyContent: 'space-between', }}>
                        <div className="second__section1" style={{ flexBasis: '50%', flex: 1, display: 'flex', flexWrap: 'nowrap', gap: '8px', justifyContent: 'start', alignItems: 'start' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                            <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, color: '#916859' }}>MEET THE FOUNDER</p>
                        </div>
                        <div className="second__section2" style={{ flexBasis: '50%', flex: 1 }}>
                            <p style={{ fontSize: isMediumScreen ? '36px' : '50px', lineHeight: isMediumScreen ? '44px' : '60px', fontWeight: 500, marginBottom: '50px', color: '#916859' }}>
                                Meet <span style={{ fontStyle: 'italic' }}>the face & brains</span> behind Dudu&apos;s World of Entertainment.
                            </p>
                            <p style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '35px', color: '#916859', marginBottom: '30px' }}>
                                As a Nigerian-born event planner in Canada, Modupe Sonayon has carved a niche for herself in the bustling events industry of Canada. Her journey
                                from Nigeria to Canada has been marked by resilience, determination, shaping her into the visionary CEO behind Dudu&apos;s World of Entertainment.
                                Her venture into event planning began over two decades ago, ignited by her love for the world of entertainment nurtured since her high school days.
                                As she navigates the intricacies of balancing work, education, and motherhood, Modupe Sonayon has established herself not only as a pioneer in the
                                field but also as a testament to resilience, dedication, and unwavering passion.
                            </p>
                        </div>
                    </div>

                    <div className="fourth__section2" style={{ display: 'flex', flexDirection: isMediumScreen ? 'column' : 'row', gap: '20px', justifyContent: 'space-between', }}>
                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    width: '100%',
                                    height: isMediumScreen ? '400px' : '560px',
                                    backgroundImage: `url(${galleryHero8.replace('/upload/', '/upload/q_auto,f_auto,w_800/')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                                alt='Cross-section of events planned by Dudu&apos;s world.'
                            ></div>
                            <div style={{ marginTop: '40px' }}>
                                <p className="fourth__section2__para1" style={{ fontWeight: 600, fontSize: '22px', lineHeight: '60px', color: '#916859' }}>Modupe Sonayan</p>
                                <p className="fourth__section2__para2" style={{ fontWeight: 400, fontSize: '22px', lineHeight: '60px', color: '#BE9A8E' }}>CEO, Event Planner & Founder</p>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    width: '100%',
                                    height: isMediumScreen ? '400px' : '989px',
                                    backgroundImage: `url(${galleryHero9.replace('/upload/', '/upload/q_auto,f_auto,w_800/')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                                alt='Cross-section of events planned by Dudu&apos;s world.'
                            >
                            </div>
                        </div>
                    </div>
                </section>

                <AwardsGallery/>

                <DuduElement />

            </section>
            <PreFooter />
            <Footer />
        </div >
    )
}